import { Link as MuiLink, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { eq, type InitialQueryBuilder } from "@tanstack/db";
import { useLiveQuery } from "@tanstack/react-db";

import { store } from "@/store/store";
import type { Item } from "@/store/types";

const filesQuery = (contentId: string) => (q: InitialQueryBuilder) =>
  q.from({ file: store.collection("file") }).where(({ file }) => eq(file.contentId, contentId));

export default function ItemFilesTable({ item }: { item: Item }) {
  const files = useLiveQuery((q) => filesQuery(item.contentId)(q)).data ?? [];

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Type</TableCell>
            <TableCell sx={{ fontFamily: "monospace", fontSize: "0.75rem" }}>ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {files.map((row) => (
            <TableRow key={row.id} sx={{ "&:last-child td": { border: 0 } }}>
              <TableCell>
                <MuiLink href={row.url} target="_blank" rel="noreferrer">
                  {row.name}
                </MuiLink>
              </TableCell>
              <TableCell>{row.mimeType}</TableCell>
              <TableCell sx={{ fontFamily: "monospace", fontSize: "0.75rem" }}>{row.id}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
